module.exports = __webpack_public_path__ + "img/exchange.c14dafd6.png";